var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { apiCreateUserPasswordReset } from '@/actions/PasswordActionsTs';
import { PasswordResetView } from '@/components/pages/password/PasswordResetView';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { passwordResetRequestedPath } from '@/utils/router/links';
/**
 * パスワード再発行
 */
export const PasswordResetPage = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    /**
     * パスワード再発行処理
     */
    const requestResetPassword = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        const action = apiCreateUserPasswordReset({ json: values }, {});
        yield wrapDispatch(dispatch, action);
        // 成功時の処理(完了画面へ遷移)
        history.push(passwordResetRequestedPath());
    }), [dispatch, history]);
    return _jsx(PasswordResetView, { onSubmit: requestResetPassword });
};
